import { createSlice } from "../helper";

const initialState = {
  options: null,
  tableData: {},
  graphData: {},
  summaryData: {
    rolewiseSummary:[],
    userwiseSummary:{}
  },
  loader: false
};

const detailedUserOutcomesSlice = createSlice({
  name: 'DetailedUserOutcomes',
  initialState,
  reducers: {
    updateOptions: (state, action) => {
      state.options = action.payload;
    },
    updateTableData: (state, action) => {
      state.tableData = action.payload;
    },
    updateGraphData: (state, action) => {
      state.graphData = action.payload;
    },
    updateSummaryData: (state, action) => {
      state.summaryData = action.payload;
    },
    updateAllData: (state, action) => {
      const { tableData, graphData, summaryData } = action.payload;
      state.tableData = tableData;
      state.graphData = graphData;
      state.summaryData = summaryData;
    },
    updateLoader: (state, action) => {
      state.loader = action.payload;
    },
    appliedFilters: (state, action) => {
      state.appliedFilters = action.payload
    }
  }
});

export const detailedUserOutcomesActions =  detailedUserOutcomesSlice.actions;

export default detailedUserOutcomesSlice;
